import React from 'react';
import { WidgetDialGaugeGraph } from '../../components';
import { Dashboard, usePromise } from '../../api';
import { widgetClick } from '../../utils/analytics';
import { numberWithCommas } from '../../utils/utils';
import { AppContext } from '../../AppContext';

import './WidgetTicketSatisfactionRating.scss';

class WidgetTicketSatisfactionRating extends React.Component {
  constructor() {
    super();

    this.state = {
      isLoading: true,
      percent: 100,
      count: 0,
    };
  }

  componentDidMount() {
    this._fetch();
  }

  _fetch = () => {
    this.setState({ isLoading: true });

    const request = Dashboard.csatPercentage();

    this.cancelRequest = request;

    request
      .then(res => {
        if (res && res.body) {
          this.setState({
            isLoading: false,
            percent: res.body.data.satisfaction_percentage,
            count: res.body.data.rating_count,
          });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch(err => {
        this.setState({ isLoading: false });
      });
  };

  componentWillUnmount() {
    this.cancelAllRequests();
  }

  componentWillUnmount() {
    this.cancelAllRequests();
  }

  cancelAllRequests = () => {
    if (this.cancelRequest && typeof this.cancelRequest.abort === 'function') {
      this.cancelRequest.abort();
    }
  };

  render() {
    const goToCSATTickets = () => {
      const link =
        '/my-organization/tickets?tab=resolved&csat_rating_name=great%7Cgood%7Cbad';
      widgetClick({ link, name: 'WidgetTicketSatisfactionRating' });
    };
    const goToTickets = () => {
      const link = '/my-organization/tickets?tab=resolved';
      widgetClick({ link, name: 'WidgetTicketSatisfactionRating' });
    };

    const { percent, isLoading, count } = this.state;

    return (
      <WidgetDialGaugeGraph
        onClick={goToCSATTickets}
        isLoading={isLoading}
        title="Satisfaction Rating"
        subtitle="in last 90 days"
        className="WidgetTicketSatisfactionRating"
        nullMessage={
          <>
            It looks like there are no recent ratings.
            <br />
            <button className="link primary" onClick={goToTickets}>
              Review Resolved Tickets
            </button>
          </>
        }
        percent={percent}
        graphSubtitle={`based on ${numberWithCommas(count) || 0} rating${
          count === '1' || count === 1 ? '' : 's'
        } submitted`}
      />
    );
  }
}

const WrappedWidgetTicketSatisfactionRating = props => (
  <AppContext.Consumer>
    {({ selectedCustomer }) => (
      <WidgetTicketSatisfactionRating
        {...props}
        selectedCustomer={selectedCustomer}
      />
    )}
  </AppContext.Consumer>
);
export default WrappedWidgetTicketSatisfactionRating;
